import React from "react";
import layoutStyle from "../assets/css/modules/shared/layout.css";
import { Urls } from "../constants/UrlConstants";

export const availableVariationTypes = { HOL: "HOL", Any: "Any" };

export default {
  PageTitle: "Marketing preferences",
  Title: "Please update your contact preferences",
  Heading: "My marketing preferences",
  Description: {
    HOL: (
      <div>
        <p>
        We'd like to tell you about any member offers plus other products, services 
        and news in the future. We need your permission to send you these promotional 
        communications so please select all the ways you are happy to receive these  from the 
        list below:
        </p>
      </div>
    ),
    MFA : (      
    <div>
        <p1>
        We'd like to tell you about any member offers plus other products, services 
        and news in the future. We need your permission to send you these promotional 
        communications so please select all the ways you are happy to receive these  from the 
        list below:
        </p1>
      </div>
      ),
    Any: (
      <p>
        We'd like to tell you about any member offers plus other products, services 
        and news in the future. We need your permission to send you these promotional 
        communications so please select all the ways you are happy to receive these  from the 
        list below:
      </p>
    )
  },
  Notice: {
    Any: (
      <p>
      By agreeing, you are giving {" "}
      <a
        className={layoutStyle.anchorDecorationUnderline}
        href={Urls.PrivacyUrl.Marketing}
        target="_blank"
        rel="noopener noreferrer"
      >
        AXA UK companies
      </a>
      {" "} permission to use the information supplied to contact you with relevant 
      information. You can withdraw your consent whenever you want by contacting us. You 
      can view our {" "}
      <a
        className={layoutStyle.anchorDecorationUnderline}
        href={Urls.PrivacyUrl.MOL}
        target="_blank"
        rel="noopener noreferrer"
      >
        privacy policy 
      </a>
      {" "}here.
    </p>
    ),
    HOL: (
      <p>
        By agreeing, you are giving {" "}
        <a
          className={layoutStyle.anchorDecorationUnderline}
          href={Urls.PrivacyUrl.Marketing}
          target="_blank"
          rel="noopener noreferrer"
        >
          AXA UK companies
        </a>
        {" "} permission to use the information supplied to contact you with relevant 
        information. You can withdraw your consent whenever you want by contacting us. You 
        can view our {" "}
        <a
          className={layoutStyle.anchorDecorationUnderline}
          href={Urls.PrivacyUrl.MOL}
          target="_blank"
          rel="noopener noreferrer"
        >
          privacy policy 
        </a>
        {" "}here.
      </p>
    )
  },
  ButtonBack: "Back",
  ButtonConfirm: "Confirm",
  ButtonContinue: "Continue",
  ValidationErrors: {
    CorrectErrors: "Please correct the following errors:",
    InvalidPersonConsentPost: "Please choose your contact preference for Post.",
    InvalidPersonConsentEmail:
      "Please choose your contact preference for Email.",
    InvalidPersonConsentSms: "Please choose your contact preference for SMS.",
    InvalidPersonConsentTelephone:
      "Please choose your contact preference for Telephone.",
    ServerError: "There was a problem submitting your request to the server."
  }
};
